import styled from 'styled-components';

export const Wrapper = styled.div<{
  $isDone: boolean;
  $isReviewMode: boolean;
  $isCorrect: boolean;
  $isWrong: boolean;
  $isSelected: boolean;
}>`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 1px 7px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  flex-shrink: 0;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
  border: 1px solid
    ${({ theme, $isSelected, $isDone, $isCorrect, $isWrong, $isReviewMode }) => {
      if ($isSelected) {
        if ($isReviewMode) {
          if ($isCorrect) return theme.colors.green7;
          if ($isWrong) return theme.colors.red7;
        }
        return theme.colors.black9;
      } else {
        if ($isReviewMode) {
          if ($isCorrect) return theme.colors.green4;
          if ($isWrong) return theme.colors.red3;
          if ($isDone) return theme.colors.black4;
          return theme.colors.black4;
        }
        return theme.colors.black4;
      }
    }};
  background: ${({ theme, $isCorrect, $isReviewMode, $isSelected, $isWrong }) => {
    if ($isSelected) {
      if ($isReviewMode) {
        if ($isCorrect) return theme.colors.green1;
        if ($isWrong) return theme.colors.red1;
        return theme.colors.black1;
      }
      return theme.colors.black1;
    }

    if ($isReviewMode) {
      if ($isCorrect) return theme.colors.green1;
      if ($isWrong) return theme.colors.red1;
      return theme.colors.black1;
    }
    return theme.colors.white;
  }};
  color: ${({ theme, $isCorrect, $isDone, $isReviewMode, $isSelected, $isWrong }) => {
    if ($isSelected) {
      if ($isReviewMode) {
        if ($isCorrect) return theme.colors.green7;
        if ($isWrong) return theme.colors.red7;
        return theme.colors.black9;
      }
      return theme.colors.black9;
    }
    if ($isCorrect && $isReviewMode) return theme.colors.green7;
    if ($isWrong && $isReviewMode) return theme.colors.red7;
    if ($isDone) return theme.colors.black4;
    return theme.colors.black9;
  }};
`;
